<button class="btn btn-primary p-2"
[class.btn-success]="dejaMange"
(click)="changerDejaManger()"
>
<span *ngIf="dejaMange==false">Jamais mangé</span> 
<span *ngIf="dejaMange">Déja mangé</span> 
</button>
